var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-cl-primary brdr-1 brdr-cl-primary brdr-square h5 cl-tertiary generic-selector",class:{'active': _vm.isActive},attrs:{"aria-label":_vm.variant.label},on:{"click":function($event){return _vm.$emit('change', _vm.variant)}}},[_vm._v(" "+_vm._s(_vm.variant.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }